import React from 'react';

import styles from './Testimonial.module.scss';

export type Testimonial = {
  partner?: string;
  quote: string;
  person?: string;
  logo?: string;
  logoAlt?: string;
};

export type TestimonialProps = {
  testimonial: Testimonial;
};

export const Testimonial: React.FC<TestimonialProps> = ({ testimonial }) => {
  return (
    <div className={styles.testimonial}>
      <div className={styles.testimonial__inner}>
        <p className={styles.testimonial__quote}>{testimonial.quote}</p>
        {testimonial.person && <p className={styles.testimonial__person}>{testimonial.person}</p>}
      </div>
    </div>
  );
};
